import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Global } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getBrowserScrollbarWidth, hideIntercom, showIntercom, deactivateScrollbar, reactivateScrollbar } from '../common/helpers.js';
export default function Overlay({
  open,
  handleClose,
  id,
  titleText,
  size = "lg",
  children,
  overflowHidden = false
}) {
  const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const scrollbarWidth = getBrowserScrollbarWidth();
  useEffect(() => {
    setTimeout(() => {
      if (open) {
          isMobile && deactivateScrollbar(scrollbarWidth);
        if (typeof window.Intercom === "function") {
            hideIntercom();
        }
      } else {
        isMobile && reactivateScrollbar();
        if (typeof window.Intercom === "function") {
            showIntercom();
        }
      }
    }, 100);
  }, [open, isMobile]);

  const drawerBleeding = 88;
  const dialogWidth = size === "sm" ? 515 : size === "md" ? 900 : 1212

  const globalStyles = {
    ".MuiDrawer-root > .MuiPaper-root": {
      maxHeight: `calc(100% - ${drawerBleeding}px)`,
      height: "auto",
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      "*::-webkit-scrollbar": {
        width: "7px",
      },
      "*::-webkit-scrollbar-track": {},
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "#CFD1D1",
        borderRadius: "5px ",
      },
      "*::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#703EFF",
      },
    },
    ".MuiDialog-paper": {
      "*::-webkit-scrollbar": {
        width: "7px",
      },
      "*::-webkit-scrollbar-track": {},
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "#CFD1D1",
        borderRadius: "5px ",
      },
      "*::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#703EFF",
      },
    },
    ".MuiDialogTitle-root": {
      padding: "24px !important",
    },
    ...(overflowHidden && {
      ".MuiDialogContent-root": {
        overflow: "hidden !important",
      }
    }),
  };

  const Root = styled("div")(() => ({
    height: "100%",
    position: "absolute",
  }));
  const StyledBox = styled(Box)(() => ({
    backgroundColor: "#fff",
  }));

  const Puller = styled(Box)(() => ({
    width: 48,
    height: 4,
    backgroundColor: "#9897A9",
    borderRadius: 3,
    position: "absolute",
    top: 16,
    left: "calc(50% - 24px)",
  }));

  const renderTitle = () => (
    <div className="r_dialogTitleText" style={{marginBottom: 0, ...(isMobile && { fontSize: 16 })}}>{titleText ?? ""}</div>
  );

  return (
    <Root>
      <CssBaseline />
      <Global styles={globalStyles} />
      <div>
        {isMobile ? (
          <SwipeableDrawer
            anchor="bottom"
            open={open}
            onOpen={() => {}}
            onClose={() => handleClose()}
            id={`${id}-drawer`}
            disableSwipeToOpen={false}
            disableScrollLock={true}
          >
            <StyledBox
              sx={{
                top: -drawerBleeding,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                visibility: "visible",
                right: 0,
                left: 0,
              }}
            >
              <Puller />
              <div className="r_drawerTitle">
                {/* <SkeletonTheme
                  baseColor="#D8DBE0"
                  highlightColor="#EDF1F6"
                  borderRadius={"4px"}
                > */}
                  {renderTitle()}
                {/* </SkeletonTheme> */}
              </div>
            </StyledBox>
            <StyledBox
              sx={{
                px: 2,
                pb: 2,
                overflow: "auto",
              }}
            >
              {children}
            </StyledBox>
            {/* {overflowHidden && <StyledBox
              sx={{
                px: 2,
                pb: 2,
                display: "flex",
                flexDirection: "column",
                maxHeight: `calc(100dvh - ${drawerBleeding}px)`, // important!
                overflow: "hidden",
              }}
            >
              <Box sx={{ flex: 1,  overflowY: "auto",
                WebkitOverflowScrolling: "touch",
                overscrollBehavior: "contain",
                pr: 1,
              }}>
                {children}
              </Box>
            </StyledBox>} */}
          </SwipeableDrawer>
        ) : (
          <Dialog
            open={open}
            onClose={() => handleClose()}
            id={`${id}-dialog`}
            aria-labelledby="responsive-dialog-title"
            PaperProps={{
              sx: {
                bgcolor: "white",
                maxWidth: "revert",
                width: dialogWidth,
                borderRadius: "8px",
              },
            }}
          >
            <DialogTitle className="r_dialogTitle">
              {renderTitle()}
              <CloseIcon
                onClick={() => handleClose()}
                className="r_dialogTitleIcon"
                style={{color: "#0D0C1C"}}
              />
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
          </Dialog>
        )}
      </div>
    </Root>
  );
}
